module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Barcode scannen":"Barcode scannen","Kamera wird gestartet…":"Kamera wird gestartet…","EAN / GTIN oder SKU in den Rahmen halten":"EAN / GTIN oder SKU in den Rahmen halten"}}')
  delete Component.options._Ctor
}
